/** The OTP guard's structured 428/429 refusals. */

export const CHALLENGE_REQUIRED_STATUS = 428;
export const CHALLENGE_REQUIRED_CODE = 'challenge_required';
export const RATE_LIMITED_CODE = 'rate_limited';
const RETRY_AFTER_HEADER = 'Retry-After';

type Detail = { code?: unknown; retry_after?: unknown } | null | undefined;

const detailOf = (data: unknown): Detail => {
  if (!data || typeof data !== 'object') return null;
  const detail = (data as { detail?: unknown }).detail;
  return detail && typeof detail === 'object' ? (detail as Detail) : null;
};

export const isChallengeRequired = (status: number, data: unknown): boolean =>
  status === CHALLENGE_REQUIRED_STATUS && detailOf(data)?.code === CHALLENGE_REQUIRED_CODE;

export const retryAfterSeconds = (data: unknown, headers?: Headers): number | undefined => {
  const fromBody = detailOf(data)?.retry_after;
  if (typeof fromBody === 'number' && fromBody > 0) return fromBody;
  const fromHeader = Number(headers?.get(RETRY_AFTER_HEADER));
  return Number.isFinite(fromHeader) && fromHeader > 0 ? fromHeader : undefined;
};
